import api from '@/apis'

export const fetchList = params => api.get(`/productCategory`, { params })
export const setActiveState = (id, isActive) => api.delete(`/productCategory/${id}`, { isActive })
export const setExt = (id, data) => api.put(`/mgroups/${id}/set_ext`, data)
